<template>
  <v-footer color="primary py-4 text-center white--text" padless>
    <v-row v-if="isLogged" justify="center" no-gutters>
      <v-btn
        v-for="item in linksForLoggedUser"
        :key="item.text"
        :to="item.link"
        color="white"
        text
        rounded
        class="my-2"
      >
        {{ item.text }}
      </v-btn>
      <v-col class="primary py-4 text-center white--text" cols="12">
        {{ new Date().getFullYear() }} — <strong>iClean team</strong>
      </v-col>
    </v-row>
    <v-row v-else justify="center" no-gutters>
      <v-btn
        v-for="item in links"
        :key="item.text"
        :to="item.link"
        color="white"
        text
        rounded
        class="my-2"
      >
        {{ item.text }}
      </v-btn>
      <v-col class="primary py-4 text-center white--text" cols="12">
        {{ new Date().getFullYear() }} — <strong>iClean team</strong>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
import store from "../store/store";
export default {
  name: "MyFooter",
  data: () => ({
    links: [
      { text: "Objednanie upratovania", link: "/" },
      { text: "Moje objednávky", link: "userOrders" },
      { text: "Prihlásenie upratovača", link: "login" }
    ],
    linksForLoggedUser: [
      {
        text: "Schvaľovanie objednávok",
        link: "cleanerOrders"
      },
      {
        text: "Voľné termíny",
        link: "termsAdministration2"
      }
    ]
  }),
  computed: {
    isLogged() {
      store.state.isLogged = (localStorage.getItem('isLogged') == 'logged');
      //return localStorage.getItem('isLogged') == 'logged';
      return store.state.isLogged;
    },
    getUserName() {
      store.state.name = localStorage.getItem('loggedUserName');
      //return localStorage.getItem('loggedUserName');
      return store.state.name;
    },
    getUserSurname() {
      store.state.name = localStorage.getItem('loggedUserSurname');
      //return localStorage.getItem('loggedUserSurname');
      return store.state.surname;
    }
  }
};
</script>
<style>
a {
  text-decoration: none;
}
</style>
